import { motion } from "framer-motion";
import { useLang } from "@/LangContext";

const reveal = {
  hidden: { opacity: 0, y: 40 },
  show: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.8, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] } }),
};

export default function Manifesto() {
  const { t } = useLang();
  return (
    <section id="approach" className="py-28 md:py-40">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="font-serif text-5xl md:text-7xl tracking-tight max-w-2xl leading-[0.9]"
        >
          {t.manifesto.title}
        </motion.h2>

        <div className="mt-20 md:mt-28 space-y-16 md:space-y-24">
          {t.manifesto.items.map((item, i) => (
            <motion.div
              key={item.n}
              custom={i}
              variants={reveal}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-80px" }}
              className="grid md:grid-cols-12 gap-6 md:gap-10 items-start border-t border-border pt-10"
            >
              <div className="md:col-span-3 font-serif text-6xl md:text-7xl text-accent/80">{item.n}</div>
              <h3 className="md:col-span-4 font-serif text-3xl md:text-4xl tracking-tight leading-tight">{item.h}</h3>
              <p className="md:col-span-5 text-lg leading-relaxed text-foreground/70 md:ml-6">{item.p}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
